import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';
import { parseContentDispositionFilename, triggerBlobDownload } from '@/utils/downloadCsvFromPost';

export type InstantPayStatementType =
  paths['/maker-organizations/{makerOrganizationUuid}/tokenized-invoices-statements/{statementId}']['get']['parameters']['query']['type'];

export interface DownloadInstantPayStatementArgs {
  makerOrganizationUuid: string;
  statementId: string;
  /** `substitution` / `offer` are one row per invoice; `substitution-summary` / `offer-summary` are the statement's summary row. */
  type: InstantPayStatementType;
}

/**
 * Download an Instant Pay substitution or offer statement CSV via SEA.
 * The filename comes from the backend's `Content-Disposition` header.
 */
export const downloadInstantPayStatement = async ({
  makerOrganizationUuid,
  statementId,
  type,
}: DownloadInstantPayStatementArgs): Promise<void> => {
  const response = await apiClient.get(
    `api/supplier-experience/maker-organizations/${makerOrganizationUuid}/tokenized-invoices-statements/${encodeURIComponent(
      statementId
    )}`,
    { searchParams: { type } }
  );
  const filename =
    parseContentDispositionFilename(response.headers.get('content-disposition')) ?? `${statementId}_${type}.csv`;
  triggerBlobDownload(await response.blob(), filename);
};
